import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    padding: "16px 20px 24px",
    boxSizing: "border-box",
    gap: 12
  },
  topGrid: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 16
  },
  siteDetailsForm: {
    width: "100%",
    "&>label": {
      minWidth: "125px",
      fontSize: "12px",
      fontWeight: "bold"
    },
    "&>div": {
      padding: "0 6px",
      boxSizing: "border-box",
      fontSize: "12px"
    }
  },
  deviceInfoTitle: {
    display: "flex",
    width: "100%",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    padding: "8px 6px",
    boxShadow: "0px 6px 7px 0px rgba(214, 206, 214, 1)",
    marginBottom: "10px",
    alignItems: "center"
  },
  onlineStatusText: {
    "& input": {
      color: "#2e7d32 !important",
      WebkitTextFillColor: "#2e7d32 !important",
      opacity: "1 !important",
      fontWeight: 700,
      cursor: "default"
    }
  },
  offlineStatusText: {
    "& input": {
      color: "#d32f2f !important",
      WebkitTextFillColor: "#d32f2f !important",
      opacity: "1 !important",
      fontWeight: 700,
      cursor: "default"
    }
  },
  configWrap: {
    marginTop: 16,
    height: 320,
    minHeight: 280,
    overflow: "hidden"
  },
  title: {
    fontWeight: 700,
    fontSize: "1.15rem"
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  syncButton: {
    textTransform: "none",
    fontWeight: 600,
    minWidth: 120,
    "&.Mui-disabled": {
      opacity: 0.45
    }
  },
  fetchButton: {
    textTransform: "none",
    fontWeight: 600,
    "&.Mui-disabled": {
      opacity: 0.45
    }
  },
  directionButton: {
    textTransform: "none",
    fontWeight: 600
  },
  recommendedButton: {
    textTransform: "none",
    fontWeight: 700,
    boxShadow: "none"
  },
  tabsBar: {
    minHeight: 40,
    "& .MuiTab-root": {
      minHeight: 40,
      textTransform: "none",
      fontWeight: 600
    }
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  section: {
    padding: 16
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 12
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 12
  },
  actions: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap"
  },
  tableScroll: {
    overflow: "visible",
    maxWidth: "100%",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6
  },
  entityTableWrap: {
    overflow: "auto",
    maxWidth: "100%",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6
  },
  entityTable: {
    width: "max-content",
    minWidth: "100%",
    borderCollapse: "separate",
    borderSpacing: 0
  },
  tableHeadRow: {
    height: 36,
    "& .MuiTableCell-root": {
      height: 36
    }
  },
  entityNameButton: {
    textTransform: "none",
    fontWeight: 600,
    padding: 0,
    minWidth: 0,
    justifyContent: "flex-start"
  },
  th: {
    "&.MuiTableCell-root": {
      padding: "8px 10px",
      fontWeight: 700,
      fontSize: "0.72rem",
      lineHeight: 1.25,
      textTransform: "uppercase",
      letterSpacing: 0.4,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.grey[100],
      whiteSpace: "nowrap"
    }
  },
  td: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle"
    }
  },
  tdMono: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.78rem",
      fontFamily: "monospace",
      verticalAlign: "middle",
      wordBreak: "break-word"
    }
  },
  diffViewer: {
    marginTop: 12,
    overflow: "auto",
    maxHeight: "75vh",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6
  },
  jsonCompareActions: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  empty: {
    color: theme.palette.text.secondary,
    padding: "12px 0"
  }
}));

export default useStyles;
